export default __webpack_public_path__ + "static/char-s-61-jp-a618fe343943432f49fadeb137411c11.webp";